"use client";

import {
  Bolt,
  Briefcase,
  Calendar,
  Clock,
  DollarSign,
  FileText,
  Gift,
  Heart,
  Lightbulb,
  LucideIcon,
  MapPin,
  MessageCircle,
  Music,
  Rocket,
  Settings,
  Shield,
  Star,
  Tag,
  Trophy,
  Truck,
  Users,
} from "lucide-react";

import SchoolTag from "@/components/shared/school/school-details/school-tag";
import { TooltipProvider } from "@/components/ui/tooltip";
import { schoolTagsTestIds } from "@/lib/data-test-ids/schools.data-test-ids";
import { SchoolDetailTagsProps } from "@/lib/types/schools.types";

const iconMap: Record<string, LucideIcon> = {
  local_shipping: Truck,
  work: Briefcase,
  time: Clock,
  sports: Trophy,
  redeem: Gift,
  favorite: Heart,
  location: MapPin,
  chat: MessageCircle,
  music: Music,
  file: FileText,
  settings: Settings,
  shield: Shield,
  sell: Tag,
  bolt: Bolt,
  calendar: Calendar,
  star: Star,
  money: DollarSign,
  people: Users,
  rocket: Rocket,
  innovation: Lightbulb,
};

export default function SchoolDetailTags({
  tags,
  schoolId,
  extraTags,
}: SchoolDetailTagsProps) {
  return (
    <TooltipProvider>
      <div
        className="flex gap-2 flex-wrap"
        data-testid={`${schoolTagsTestIds.SCHOOL_TAGS}-${schoolId}`}
      >
        {tags.map((tag) => {
          const IconComponent = iconMap[tag.icon];

          return (
            <SchoolTag
              key={tag.name}
              IconComponent={IconComponent}
              title={tag.name}
              tooltip={tag.tooltip_text}
            />
          );
        })}
        {extraTags}
      </div>
    </TooltipProvider>
  );
}
